import React, { memo } from 'react';
import styled from 'styled-components';

import { translate } from '../../../../common/translation/translate';
import { ErrorBoundaryIcon } from '../../../common/errorBoundary/errorBoundaryIcon';
import { 
    Container, 
    IconWrapper, 
    MapStoriesViewNoDataBodyText, 
    MapStoriesViewNoDataHeaderText, 
    MapStoriesViewNoDataHeaderTextIconWrapper, 
    NoDataBodyText, 
    NoDataHeaderText, 
    NoDataHeaderTextIconWrapper } from './commonErrorStyles';

interface DefaultAqiErrorUIProps {
  isHealthAdvice?: boolean;
  isStoriesUI?: boolean;
}

export const DefaultAqiErrorUI = memo(({ isHealthAdvice, isStoriesUI }: DefaultAqiErrorUIProps) => {
    if (isStoriesUI) {
        return (
            <StoriesContainer>
                <MapStoriesViewNoDataHeaderTextIconWrapper>
                    <IconWrapper isMapOrStoriesView={isStoriesUI}>
                        <ErrorBoundaryIcon />
                    </IconWrapper>
                    <MapStoriesViewNoDataHeaderText>{translate('failedToLoad')}</MapStoriesViewNoDataHeaderText>
                </MapStoriesViewNoDataHeaderTextIconWrapper>
                <MapStoriesViewNoDataBodyText>{translate('dataLoadErrorMessage')}</MapStoriesViewNoDataBodyText>
            </StoriesContainer>
        );
    }
    return (
        <Container isHealthAdvice={isHealthAdvice} >
            <NoDataHeaderTextIconWrapper>
                <IconWrapper>
                    <ErrorBoundaryIcon />
                </IconWrapper>
                <NoDataHeaderText>{translate('failedToLoad')}</NoDataHeaderText>
            </NoDataHeaderTextIconWrapper>
            <NoDataBodyText>{translate('dataLoadErrorMessage')}</NoDataBodyText>
        </Container>
    );
});

DefaultAqiErrorUI.displayName = 'DefaultAqiErrorUI';

const StoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #F9F9F9;
  width: 100%;
  height: 376px;
  padding: 12px;
`;
